import { useNavigate, useParams, useLocation } from "react-router-dom";
import { useSelector } from "react-redux";
import { fetcher } from "../../../../services/fetcher";
import { USER_TYPES } from "../../../../utils/userTypes";
import { Paper } from "@mantine/core";
import QRCodeForm from "../../forms/QRCodeForm/QRCodeForm";
import { successNotifications, errorNotifications } from "../../../../utils/handleNotifications";

const AddOperatorLink = () => {
  const navigate = useNavigate();
  const { uuid: paramUuid } = useParams();
  const location = useLocation();
  const operatorProfile = useSelector((state) => state.operatorProfile);
  const { user_type } = useSelector((state) => state.auth);

  // Determine the correct UUID based on user type
  const uuid =
    user_type[0] === USER_TYPES.OPERATOR && operatorProfile?.uuid
      ? operatorProfile.uuid
      : paramUuid || null;

  console.log("UUID being used:", uuid); // Debugging UUID

  const isEditMode = location.state?.editData;
  const endpoint = uuid
    ? `operator/operator-links/${uuid}/${isEditMode ? isEditMode.id + "/" : ""}`
    : null;
    

  const handleSubmit = async (payload) => {
    if (!endpoint) {
      console.error("No valid UUID found. Cannot proceed with submission.");
      errorNotifications("Invalid UUID. Please try again.");
      return;
    }

    try {
      await fetcher(endpoint, isEditMode ? "PATCH" : "POST", payload, {
        "content-type": "multipart/form-data",
      });
      successNotifications(isEditMode ? "QR Code updated successfully" : "QR Code created successfully");
      navigate(-1);
    } catch (error) {
      console.error(error);
      errorNotifications(error.response?.data || "An error occurred", error);
    }
  };

  return (
    <Paper shadow="xl" p="xl">
      <QRCodeForm onSubmit={handleSubmit} initialData={isEditMode || null} />
    </Paper>
  );
};

export default AddOperatorLink;